import { lazy } from 'react';

export const AssignmentsPage = lazy(() => import('./AssignmentsPage'));
